// extracted by mini-css-extract-plugin
module.exports = {"NavBar":"NavBar_NavBar__-XYZQ","link":"NavBar_link__2Iixg","image":"NavBar_image__3x6Bk"};